
import axios from 'axios'
import moment from 'moment'
import feathers from '@feathersjs/feathers'
import rest from '@feathersjs/rest-client'
import authentication from '@feathersjs/authentication-client'

import { API_BASE_URL } from '@/config'

export const state = {
  client: feathers()
    .configure(rest(API_BASE_URL).axios(axios))
    .configure(authentication({
      path: 'auth',
    })),
  services: {
    ads: 'ad-slots',
    adsAmortization: 'ads-amortization',
    appLogs: 'app-logs',
    dashboardAdmin: 'dashboard-admin',
    deals: 'deals',
    hubspot: 'hubspot',
    matches: 'matches',
    meta: 'meta',
    organizations: 'organizations',
    products: 'products',
    providers: 'providers',
    passwordResets: 'password-resets',
    reviews: 'reviews',
    reviewsProviders: 'reviews-providers',
    twilio: 'twilio',
    users: 'users',
  },
}

export const actions = {
  login ({ state }, options = {}) {
    return state.client.authenticate({
      ...options,
      strategy: options.strategy || 'local',
    })
  },

  logout ({ state }) {
    return state.client.logout()
  },

  getRecentDeals ({ getters }, userId) {
    return getters.apiDeals.find({
      query: {
        $sort: { createdAt: -1 },
        $select: ['id', 'createdAt'],
        createdAt: {
          $gte: moment().subtract(1, 'month').toDate(),
        },
        userId,
      },
    })
  },

  sendCommand ({ state }, command) {
    return state.client.service(`commands/${command}`).find()
  },
}

export const getters = {
  apiAds: ({ client, services }) => client.service(services.ads),
  apiAdsAmortization: ({ client, services }) => client.service(services.adsAmortization),
  apiDashboardAdmin: ({ client, services }) => client.service(services.dashboardAdmin),
  apiDeals: ({ client, services }) => client.service(services.deals),
  apiHubspot: ({ client, services }) => client.service(services.hubspot),
  apiLogs: ({ client, services }) => client.service(services.appLogs),
  apiMatches: ({ client, services }) => client.service(services.matches),
  apiMeta: ({ client, services }) => client.service(services.meta),
  apiOrganizations: ({ client, services }) => client.service(services.organizations),
  apiPasswordResets: ({ client, services }) => client.service(services.passwordResets),
  apiProducts: ({ client, services }) => client.service(services.products),
  apiProviders: ({ client, services }) => client.service(services.providers),
  apiReviews: ({ client, services }) => client.service(services.reviews),
  apiReviewsProviders: ({ client, services }) => client.service(services.reviewsProviders),
  apiTwilio: ({ client, services }) => client.service(services.twilio),
  apiUsers: ({ client, services }) => client.service(services.users),
}

export const mutations = {}
export const namespaced = true
